import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDatabaseIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Database",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M7 1.3125C4.05617 1.3125 1.75 2.65781 1.75 4.375V9.625C1.75 11.3422 4.05617 12.6875 7 12.6875C9.94383 12.6875 12.25 11.3422 12.25 9.625V4.375C12.25 2.65781 9.94383 1.3125 7 1.3125ZM11.375 7C11.375 7.52609 10.9441 8.06258 10.1932 8.47219C9.34773 8.9332 8.21352 9.1875 7 9.1875C5.78648 9.1875 4.65227 8.9332 3.8068 8.47219C3.05594 8.06258 2.625 7.52609 2.625 7V6.09C3.55797 6.91031 5.1532 7.4375 7 7.4375C8.8468 7.4375 10.442 6.90813 11.375 6.09V7ZM3.8068 2.90281C4.65227 2.4418 5.78648 2.1875 7 2.1875C8.21352 2.1875 9.34773 2.4418 10.1932 2.90281C10.9441 3.31242 11.375 3.84891 11.375 4.375C11.375 4.90109 10.9441 5.43758 10.1932 5.84719C9.34773 6.3082 8.21352 6.5625 7 6.5625C5.78648 6.5625 4.65227 6.3082 3.8068 5.84719C3.05594 5.43758 2.625 4.90109 2.625 4.375C2.625 3.84891 3.05594 3.31242 3.8068 2.90281ZM10.1932 11.0972C9.34773 11.5582 8.21352 11.8125 7 11.8125C5.78648 11.8125 4.65227 11.5582 3.8068 11.0972C3.05594 10.6876 2.625 10.1511 2.625 9.625V8.715C3.55797 9.53531 5.1532 10.0625 7 10.0625C8.8468 10.0625 10.442 9.53313 11.375 8.715V9.625C11.375 10.1511 10.9441 10.6876 10.1932 11.0972Z",
			fill: "currentColor"
		})
	})
});
export default SvgDatabaseIcon;
